import { Component, inject, Input, OnChanges } from '@angular/core';
import { AbstractSubmissionFormComponent } from '../submission-forms/abstract-submission-form/abstract-submission-form.component';
import { ChangePersonalDetailsRequest } from '../../../../models/users/requests/submissionRequests/change-personal-details-request';
import { PersonalInfoSubmissionFormViewModel } from './personal-info-submission-form-view-model';
import { MediaUtils } from '../../../../utils/media-utils';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { StringExtensions } from '../../../../utils/string.extensions';

@Component({
  selector: 'app-personal-info-submission-form',
  templateUrl: './personal-info-submission-form.component.html',
  styleUrls: ['./personal-info-submission-form.component.scss'],
  providers: [PersonalInfoSubmissionFormViewModel]
})
// prettier-ignore
/* eslint-disable brace-style */
export class PersonalInfoSubmissionFormComponent
  extends AbstractSubmissionFormComponent<ChangePersonalDetailsRequest>
  implements OnChanges
{
  /* eslint-enable brace-style */
  protected viewModel = inject(PersonalInfoSubmissionFormViewModel);

  @Input() decryptedMemberSIN: string = '';
  @Input() canViewFullSIN: boolean = true;

  public req!: ChangePersonalDetailsRequest;
  public programmaticBirthdate = '';
  public programmaticSIN = '';

  public readonly loadingOpts$ = this.viewModel.loadingOpts$;
  public readonly genderDropdowns$ = this.viewModel.genderDropdowns$;
  public readonly pronounDropdowns$ = this.viewModel.pronounDropdowns$;
  public readonly isMobile$ = this.screenService.isMobile$;

  private _infoChanged = new BehaviorSubject<boolean>(false);
  public readonly infoChanged$ = this._infoChanged as Observable<boolean>;

  ngOnChanges(): void {
    this.req = new ChangePersonalDetailsRequest(this.user, this.decryptedMemberSIN);
    this.programmaticBirthdate = this.req.birthdate;
    this.programmaticSIN = this.decryptedMemberSIN;
  }

  public formSubmitted(req: ChangePersonalDetailsRequest): void {
    req.birthdate = StringExtensions.convertDateFormatForBackend(req.birthdate);
    if (!!this.fileUploader) {
      combineLatest([this.infoChanged$, this.fileUploader.selectedFiles$]).once(([changed, files]) => {
        if (changed) {
          const promises = files.map(file => MediaUtils.fileToUserFile(file));
          Promise.all(promises).then(userFiles => {
            this.viewModel.submitRequest(req, userFiles);
          });
        } else {
          this.viewModel.submitRequest(req);
        }
      });
    }
  }

  formChanged(current: ChangePersonalDetailsRequest): void {
    if (this.req.genderId !== current.genderId || this.req.birthdate !== current.birthdate) {
      this._infoChanged.next(true);
    } else {
      this._infoChanged.next(false);
    }

    if (this.canViewFullSIN) {
      if (this.req.socialInsuranceNumber !== current.socialInsuranceNumber) {
        this._infoChanged.next(true);
      }
    }
  }

  protected readonly MediaUtils = MediaUtils;
  protected readonly StringExtensions = StringExtensions;
}
